// Tiny HTML templating. Every interpolated value is escaped unless it is the
// result of another html`` call (or explicitly wrapped with raw()), so content
// and user notes can never inject markup.

const ESC = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function esc(value) {
  return String(value ?? '').replace(/[&<>"']/g, (c) => ESC[c]);
}

class Safe {
  constructor(s) {
    this.s = s;
  }
  toString() {
    return this.s;
  }
}

export function raw(s) {
  return new Safe(String(s));
}

function renderValue(v) {
  if (v === null || v === undefined || v === false || v === true) return '';
  if (v instanceof Safe) return v.s;
  if (Array.isArray(v)) return v.map(renderValue).join('');
  return esc(v);
}

export function html(strings, ...values) {
  let out = strings[0];
  for (let i = 0; i < values.length; i++) out += renderValue(values[i]) + strings[i + 1];
  return new Safe(out);
}

// Joins class names, skipping falsy ones: cx('a', cond && 'b').
export function cx(...names) {
  return names.filter(Boolean).join(' ');
}

// Plain text -> paragraphs, for content that uses blank lines between paragraphs.
export function paragraphs(text, className = '') {
  return html`${String(text || '').split(/\n\n+/).map((p) => html`<p${className ? raw(` class="${esc(className)}"`) : ''}>${p}</p>`)}`;
}
